import { useSelector } from "react-redux";
import Error401 from "../../assets/images/errors/error401.png";
import Navbar from "../../components/navigation/Navbar";

const NotAuthorized = () => {
  const isAuth = useSelector((state) => state.user.isAuthenticated);

  return (
    <div className="bg-bkg pt-3 px-10">
      {!isAuth && <Navbar />}
      <div className="flex flex-col items-center justify-center p-4">
        <h4 className="font-semibold text-text-1 mb-4 text-center">
          You are not authorized to view this page or perform this action.
        </h4>
        <img
          src={Error401}
          alt="Not Authorized"
          className="w-64 h-64 md:w-80 md:h-80 mb-8 object-cover"
        />
        <p className="text-text-1/60 text-center max-w-md">
          Please contact your administrator,
        </p>
      </div>
    </div>
  );
};

export default NotAuthorized;
